import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import SlideAddFormTableHead from './SlideAddFormTableHead';
const SlideAddFormTableFieldsArray = (props) => {
    const { fields, render } = props;
    const onClickDelete = useCallback((e) => {
        const index = parseInt(e.currentTarget.value, 10);
        fields.remove(index);
    }, [fields]);
    return (_jsxs("table", Object.assign({ className: 'mypage_slide_table' }, { children: [_jsx(SlideAddFormTableHead, {}), _jsx("tbody", { children: fields.length === 0 ? (_jsx("tr", { children: _jsx("td", Object.assign({ className: 'empty_col', colSpan: 6 }, { children: "\u30D5\u30A1\u30A4\u30EB\u304C\u8FFD\u52A0\u3055\u308C\u3066\u3044\u307E\u305B\u3093" })) })) : (fields.map((field, index) => render({
                    field,
                    index,
                    length: fields.length,
                    onClickDelete,
                }))) })] })));
};
SlideAddFormTableFieldsArray.propTypes = {
    fields: propShape().isRequired,
    render: propFunc().isRequired,
};
export default SlideAddFormTableFieldsArray;
